import internalEventCodes from 'event-system/codes/internal';
import externalEventCodes from 'event-system/codes/external';

class PostsStore {

  constructor(application, serverInterface) {

    this.cache = {};

    this.application = application;
    this.serverInterface = serverInterface;

    this.registerEventHandlers();

  }

  registerEventHandlers() {

    function handlePostUpdatedEvent(post) {

      this.cache[post._id] = post;

    }

    function handleExternalPostUpdatedEvent(data) {

      const post = data.posts[0];

      handlePostUpdatedEvent.call(this, post);
    }

    this.application.eventSystem.internal.on(internalEventCodes.POST_UPDATED, handlePostUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.POST_UPDATED, handleExternalPostUpdatedEvent.bind(this));

  }

  setData(posts) {

    for (let post of posts) {

      const postId = post._id;

      this.cache[postId] = post;

    }

  }

  async getPostBasicDetailsById(postId, skipCache = false) {

    let post = this.cache[postId];

    if (skipCache === false && post !== void 0) {
      return post;
    }

    const postDetails = await this.serverInterface.startup.community.getFullPostById(postId);

    this.cache[postId] = postDetails.post;

    return this.cache[postId];

  }

}

export default PostsStore;